import styled from 'styled-components';

import { bidiProse } from 'components/bidi';

export const Container = styled.div`
  padding: var(--s7) var(--s5);
  text-align: center;

  &.sm {
    padding: var(--s6) var(--s4);
  }
`;

export const Icon = styled.div`
  width: 44px;
  height: 44px;
  margin: 0 auto var(--s4);
  border-radius: var(--r-md);
  background: var(--surface-alt);
  border: 1px solid var(--line);
  display: grid;
  place-items: center;
  color: var(--text-faint);

  svg {
    width: 20px;
    height: 20px;
    stroke-width: 1.6;
  }
`;

/* Both of these quote the search term back, which can be Arabic. */
export const Title = styled.h3`
  ${bidiProse};
  text-align: center;
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-body);
  color: var(--text);
  margin-bottom: var(--s1);
`;

export const Text = styled.p`
  ${bidiProse};
  text-align: center;
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text-muted);
  max-width: 340px;
  margin: 0 auto;
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--s2);
  margin-top: var(--s4);
`;
